import gql from 'graphql-tag'
export default gql`mutation deleteChlorideClassMutation($chlorideClassId: Int!) {
  deleteChlorideClass(chlorideClassId: $chlorideClassId) {
    success
  }
}`